import { render, staticRenderFns } from "./OperationRecords.vue?vue&type=template&id=7fb35c22&"
import script from "./OperationRecords.vue?vue&type=script&lang=js&"
export * from "./OperationRecords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports